export const normalizeLanguage = (language) => (
  language || 'fr'
).split('-')[0].toLowerCase();

export const getLocalizedField = (item, field, language, fallback = '') => {
  if (!item) return fallback;

  const currentLanguage = normalizeLanguage(language);
  const translations = item?.[`${field}_translations`] || {};
  const localizedValue = item?.[`localized_${field}`];
  const originalValue = item?.[field];

  if (translations[currentLanguage]) {
    return translations[currentLanguage];
  }

  if (localizedValue) {
    const localizedLanguage = Object.entries(translations).find(([, value]) => value === localizedValue)?.[0];
    if (!localizedLanguage || normalizeLanguage(localizedLanguage) === currentLanguage) {
      return localizedValue;
    }
  }

  return originalValue || fallback;
};
